import { FGSelectInput } from "nsitools-react";
import * as React from "react";
import * as Yup from "yup";

import { BreedVarietyApi, SaveBreedVarietyAndExceptionDto } from "../../../../../api";
import { SmallFormGenerator } from "../../../../../components";
import { useApiService, useSaveApi, useTl } from "../../../../../hooks";
import { useReferential } from "../../../../../hooks/useReferential";
import { ETLCodes } from "../../../../../locales";

export interface IBreedVarietyPanelProps {
  breedId: number;
  onSaved: () => void;
}

export const BreedVarietyPanel: React.FunctionComponent<IBreedVarietyPanelProps> = ({ breedId, onSaved }) => {
  const { t } = useTl();
  const api = useApiService(BreedVarietyApi);

  const [breeds, bloading] = useReferential((a) => a.getBreeds(null), true, []);

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      destinationBreedId: Yup.number().nullable().required(t(ETLCodes.Required)),
    });
  }, [t]);

  const { saving, saveItem } = useSaveApi<SaveBreedVarietyAndExceptionDto>(
    React.useMemo(
      () => ({
        saveApiFn: (data) => api.saveBreedVariety(data),
        onSaveFn: () => onSaved(),
      }),
      [api, onSaved]
    )
  );

  const initialData = React.useMemo(
    () => new SaveBreedVarietyAndExceptionDto({ sourceBreedId: breedId }).toJSON(),
    [breedId]
  );

  return (
    <SmallFormGenerator
      onSubmit={saveItem}
      initialValues={initialData}
      editMode={true}
      validationSchema={FormSchema}
      minLabelWidth={110}
      saving={saving}
    >
      <FGSelectInput name="destinationBreedId" items={breeds} loading={bloading} label={t(ETLCodes.BreedVariety)} />
    </SmallFormGenerator>
  );
};
